import ApiService from "./ApiService"

export default {
    get(id) {
        return ApiService().get(`api/projects/${id}`);
    },
    search(search) {
        let params = new URLSearchParams();
        if(search.output)
            params.append('output', search.output);
        if(search.search && search.search.length > 0)
            params.append('term', search.search);
        if(search.companyId && search.companyId > 0)
            params.append('companyId', search.companyId);
        if(search.state)
            params.append('enabled', search.state == 'Active' ? true : false);

        let qs = params.toString();
        if(qs && qs.length > 0)
            qs = "?" + qs;
        return ApiService().get(`api/projects/${search.offset}/${search.limit}${qs}`);
    },
    post(body) {
        return ApiService().post(`api/projects`, body);
    },
    put(id, body) {
        return ApiService().put(`api/projects/${id}`, body);
    },
    delete(id) {
        return ApiService().delete(`api/projects/${id}`, {});
    }
}